// Copyright 2023 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
import {useMemo} from "react";
import {Checkbox, Form, Modal} from "antd";
import i18next from "i18next";
import React from "react";
import * as Setting from "../../Setting";

export const AgreementModal = (props) => {
  const {
    open,
    onOk,
    onCancel,
    closable = false,
    okButtonProps = {},
    cancelButtonProps = {},
    okText = i18next.t("signup:Accept"),
    cancelText = i18next.t("signup:Decline"),
    loginMethod,
  } = props;
  // const {open, onOk, onCancel, application} = props;
  // const [doc, setDoc] = useState("");

  // useEffect(() => {
  //   getTermsOfUseContent(application.termsOfUse).then((data) => {
  //     setDoc(data);
  //   });
  // }, []);

  // const renderE

  const policyContent = useMemo(() => (
    <div style={{maxHeight: "350px", overflowY: "scroll"}}>
      <p>晶科客户网站账号相关隐私协议</p>
      <p>
        <div>
        晶科账号统一登录服务由晶科能源股份有限公司（下文简称“晶科”）运营，是晶科公司对外提供身份认证的唯一入口。本隐私声明（“本声明”）适用于账号登录服务（以下称“账号登录””、“统一登录”、“我们”、或“本服务”）为您提供服务过程中收集和使用信息的形式，请您在使用本服务并向我们提交个人数据前，仔细阅读、了解本隐私声明。若您勾选“同意”，则意味着您充分明确地了解下述信息收集和使用行为以及您所拥有的权利等事宜。
        </div>
        <div>本声明阐述了我们如何收集以及处理您的个人数据，通过阅读本声明，我们希望您了解以下内容：</div>
      </p>
      <p>
        <div>1.我们如何收集和使用您的个人数据</div>
        <div>2.我们如何使用 Cookie 和同类技术</div>
        <div>3.我们如何披露您的个人数据</div>
        <div>4.我们如何访问或修改您的个人数据</div>
        <div>5.我们如何保护和留存您的个人数据</div>
        <div>6.您的个人数据如何在全球范围转移</div>
        <div>7.特别说明</div>
        <div>8.本声明的更新</div>
        <div>8.联系信息</div>
      </p>
      <h2>1. 本服务如何收集和使用您的个人数据</h2>
      <div>个人数据是指单独使用或结合其他信息使用时能够确定个人身份的信息。我们会收集您在本服务上创建、修改或登录您的账户时向我们提供的个人数据，包括您输入的名字、账号、密码、邮箱、电话。同时，在您使用本服务的过程中，系统会生成一些日志信息，其中包括记录您的IP 地址、访问日期和时间。在您使用本服务的过程中，我们会基于以下目的使用您的个人数据：</div>
      <div>
        1） 为您创建晶科账户；<br />
        2） 为您使用晶科公司服务提供身份认证；<br />
        3） 为您管理和处理认证结果，提供客户支持和故障的定位、排除；<br />
        4） 与您联系，向您发送重要通知；<br />
        5） 保护我们产品和服务的安全；<br />
        6） 开展内部审计、数据分析和研究，改善我们的产品和服务。<br />
        7） 遵守和执行所适用的法律法规要求、相关的行业标准或我们的政策。<br />
      </div>
      <h2>2. 本服务如何使用 Cookie 和同类技术</h2>
      <div>为确保网站正常运转，我们有时会在计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 是一种网络服务器存储在计算机或移动设备上的纯文本文件。Cookie 的内容只能由创建它的服务器检索或读取。每个 Cookie 对您的网络浏览器或移动应用程序都是唯一的。Cookie 通常包含标识符、站点名称以及一些号码和字符。借助于 Cookie：</div>
      <div>
      （1）网站能够记住用户的单次访问（使用会话 Cookie）或多次访问（使用永久 Cookie），可简化您重复登录的步骤，帮助判断您的登录状态以及账户或数据安全；<br />
      （2）网站能够保存个人偏好设置，例如计算机或移动设备的语言、字体大小和其他浏览偏好。<br />
      本服务不会将 Cookie 用于本声明所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookie。有关详情，请参见 AboutCookies.org 。 您可以清除计算机上保存的所有 Cookie，但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。<br />
      如需详细了解如何更改浏览器设置，请访问以下关于不同浏览设备厂商提供的相关链接： <br />
      Internet Explorer :<br />
        <a href="http://support.microsoft.com/kb/260971">http://support.microsoft.com/kb/260971</a><br />
      Google Chrome :<br />
        <a href="https://support.google.com/chrome/bin/answer.py?hl=en-GB&answer=95647&p=cpn_cookies">https://support.google.com/chrome/bin/answer.py?hl=en-GB&answer=95647&p=cpn_cookies</a><br />
      Mozilla Firefox : <br />
        <a href="http://support.mozilla.org/en-US/kb/Cookies">http://support.mozilla.org/en-US/kb/Cookies</a><br />
      Safari :<br />
        <a href="http://support.apple.com/kb/PH5042">http://support.apple.com/kb/PH5042</a><br />
      Opera :<br />
        <a href="http://www.opera.com/browser/tutorials/security/privacy/">http://www.opera.com/browser/tutorials/security/privacy/</a><br />
      </div>
      <h2>3. 本服务如何披露您的个人数据</h2>
      <div>在适用的法律要求或响应法律程序的情况下，晶科可能会向相关的执法机关或者其他政府机关披露您的个人数据。在某些管辖区，如果晶科牵涉到重组、合并或破产和清理诉讼，那么您的数据还可能会被披露给交易方。晶科还会在存在合理需求的情况下披露您的数据，例如出于执行合同以及我们认为为阻止身体损害或财产损失或调查可能的或实际的非法行为有必要披露且披露是适当的。</div>
      <h2>4. 本服务如何访问或修改您的个人数据</h2>
      <div>
        4.1 您应确保提交的所有个人数据都准确无误。晶科会尽力维护个人数据的准确和完整，并及时更新这些数据。<br />
        4.2 当使用的法律要求的情况下，您可能：<br />
        (1)有权访问我们持有的关于您的特定的个人数据；<br />
        (2)要求我们更新或更正持有的您的不准确的个人数据；<br />
        (3)拒绝或限制我们使用您的个人数据；以及<br />
        (4)要求我们删除您的个人数据。<br />
        如果您想行使相关的权利，请通过  serviceinfo@jinkosolar.com 反馈给我们。 为保障安全，您可能需要提供书面请求。如果我们有合理依据认为这些请求存在欺骗性、无法实行或损害他人隐私权，我们则会拒绝处理请求<br />
        4.3 当适用的法律要求的情况下，您还有权撤销您的同意，但撤销不影响我们撤销前基于您的同意对您个人数据处理的合法性及效力，也不影响我们基于其他适用的合法性基础而进行的数据处理行为。<br />
        4.4 如果您认为我们对您的个人信息的处理不符合适用的数据保护法律，您可以与法定的数据保护机构联系。欧盟地区数据保护机构的联系方式请参考：<a href="http://ec.europa.eu/justice/article-29/structure/data-protection-authorities/index_en.html">http://ec.europa.eu/justice/article-29/structure/data-protection-authorities/index_en.html</a> <br />
      </div>
      <h2>5. 本服务如何保护和留存您的个人数据</h2>
      <div>
        晶科重视个人与企业的数据安全。我们采用适当的物理、管理和技术保障措施来保护您的数据不被未经授权访问、披露、使用、修改、损坏或丢失。例如，我们会使用加密技术确保数据的机密性；我们会使用保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人数据；以及我们会举办安全和隐私保护培训课程，加强员工对于数据保护重要性的认识。我们会尽力保护您的个人数据，但是请注意任何安全措施都无法做到无懈可击。<br />
        我们不会以非本声明中定义的目的保存您的数据。<br />
      </div>
      <h2>6. 您的个人数据如何在全球范围转移</h2>
      <div>晶科是一家跨国公司，这意味着，晶科收集的您的个人数据可能会在您使用产品或服务所在国家/地区、在晶科或其关联公司、子公司或服务提供商、业务合作伙伴设有机构的其他国家/地区进行处理，或者受到来自这些国家/地区的访问。本服务收集的数据可能会跨国界而传输到您使用我们服务所在国家或地区之外的其他国家和地区，这些国家/地区的数据保护法可能不同，在此类情况下，晶科会采取措施确保我们收集的数据依据本声明和适用法律的要求进行处理。</div>
      <div>包括当位于欧盟的数据主体的个人数据被转移至不被欧盟认可的同等数据保护水平国家或地区时，晶科会使用各种法律机制，如签署欧盟委员会批准的标准合同条款或请求您对跨境转移个人数据的同意，或者在跨境数据转移之前实施数据匿名等安全举措。</div>
      <h2>7. 特别说明</h2>
      <div>如您是未满十四周岁的未成年人，在提交个人信息或要求我们处理您的个人信息前您应取得您的父母或其他监护人同意。</div>
      <h2>8. 本声明的更新</h2>
      <div>我们可能会不定期修改、更新本隐私声明，如果涉及重大变更，届时我们会提供显著的通知，尽可能通过可行的渠道和方法，将变更通知您。</div>
      <h2>9. 联系信息</h2>
      <div>如果您对本声明有任何疑问、意见或投诉，请通过发送邮件至 serviceinfo@jinkosolar.com 与我们联系。</div>
      <p>最近更新日期：2023 年 7 月</p>
      <p>版权所有 © 晶科能源股份有限公司 2023 保留一切权利。</p>
    </div>
  ), []);

  const announcementContent = useMemo(() => (
    <div style={{maxHeight: "350px", minHeight: "150px"}}>
      {i18next.t("Disclaimer:This system is only used for individual customer to offer customer service,and the collected information will be only used for claims.")}
    </div>
  ), [Setting.getLanguage()]);
  return (
    <Modal
      // title={i18next.t("signup:Terms of Use")}
      title={loginMethod === "phone" ? i18next.t("login:《Privacy Policy》") : i18next.t("signup:Announcement")}
      open={open}
      width={Setting.isMobile() ? "80vw" : "50vw"}
      closable={closable}
      okText={okText}
      cancelText={cancelText}
      onOk={onOk}
      onCancel={onCancel}
      okButtonProps={okButtonProps}
      cancelButtonProps={cancelButtonProps}
    >
      {loginMethod === "phone" ? policyContent : announcementContent}
      {/* <iframe title={"terms"} style={{border: 0, width: "100%", height: "60vh"}} srcDoc={doc} /> */}
    </Modal>
  );
};

// function getTermsOfUseContent(url) {
//   return fetch(url, {
//     method: "GET",
//   }).then(r => r.text());
// }

export function isAgreementRequired(application) {
  if (application) {
    const agreementItem = application.signupItems.find(item => item.name === "Agreement");
    if (!agreementItem || agreementItem.rule === "None" || !agreementItem.rule) {
      return false;
    }
    if (agreementItem.required) {
      return true;
    }
  }
  return false;
}

function initDefaultValue(application) {
  const agreementItem = application.signupItems.find(item => item.name === "Agreement");

  return isAgreementRequired(application) && agreementItem.rule === "Signin (Default True)";
}

export function renderAgreementFormItem(application, required, layout, ths, loginMethod) {
  const language = Setting.getLanguage();
  return (<React.Fragment>
    <Form.Item
      name="agreement"
      key="agreement"
      valuePropName="checked"
      className="checkboxFormItem"
      rules={[
        {
          required: required,
        },
        () => ({
          validator: (_, value) => {
            if (!required) {
              return Promise.resolve();
            }

            if (!value) {
              const msg = loginMethod === "phone" ? i18next.t("signup:Please accept the 《Privacy Policy》!") : i18next.t("signup:Please accept the 《Announcement》!");
              return Promise.reject(msg);
            } else {
              return Promise.resolve();
            }
          },
        }),
      ]
      }
      // {...layout}
      initialValue={initDefaultValue(application)}
    >
      {language === "ja" ? (
        <Checkbox>
          <a onClick={() => {
            ths.setState({
              isTermsOfUseVisible: true,
            });
          }}
          >
            {/* {i18next.t("")} */}
            {loginMethod === "phone" ? i18next.t("login:《Privacy Policy》") : `${i18next.t("signup:Announcement")}`}
          </a>
          &nbsp;
          {loginMethod === "phone" ? i18next.t("signup:I have read and agree") : i18next.t("signup:I have read and understand")}
        </Checkbox>
      ) : (
        <Checkbox>
          {loginMethod === "phone" ? i18next.t("signup:I have read and agree") : i18next.t("signup:I have read and understand")}
          &nbsp;
          <a onClick={() => {
            ths.setState({
              isTermsOfUseVisible: true,
            });
          }}
          >
            {/* {i18next.t("")} */}
            {loginMethod === "phone" ? i18next.t("login:《Privacy Policy》") : `${i18next.t("signup:Announcement")}`}
          </a>
        </Checkbox>
      )}
    </Form.Item>
    <AgreementModal application={application} layout={layout} open={ths.state.isTermsOfUseVisible} loginMethod={loginMethod}
      onOk={() => {
        ths.form.current.setFieldsValue({agreement: true});
        ths.setState({
          isTermsOfUseVisible: false,
        });
      }}
      onCancel={() => {
        ths.form.current.setFieldsValue({agreement: false});
        ths.setState({
          isTermsOfUseVisible: false,
        });
      }} />
  </React.Fragment>
  );
}
